// slider
const swiper = new Swiper('.swiper.feedback-slider', {
    loop: false,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// phone mask
$(function () {
    $("[name='phone']").each(function (index) {
        index++;
        let iti, input;
        input = this;

        //инициализация маски
        iti = window.intlTelInput(input, {
            preferredCountries: ['it'],
            separateDialCode: true,
            autoPlaceholder: "aggressive",
            initialCountry: "auto",
            hiddenInput: "full_phone",
            geoIpLookup: function (success, failure) {
                $.get("https://ipinfo.io", function () { }, "jsonp").always(function (resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "ru";
                    success(countryCode);
                });
            },
            nationalMode: true,
            utilsScript: "../components/bem-blocks/mask/mask2.js",
        });
        // завершение инициализации
    });
});

// rng в счётчике
$(document).ready(function () {
    function randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
    const nowOnline = randomIntFromInterval(2850, 3160);
    $(".now-online__count").html(nowOnline);
});

// post date
$(document).ready(function () {
    var postDate = new Date();
    postDate.setDate(postDate.getDate() - 13);
    postDate = postDate.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });

    $(".heading-block__date").html(postDate);
});

// timer
$(document).ready(function () {
    function Timer(duration, display) {
        var timer = duration, hours, minutes, seconds;
        setInterval(function () {
            hours = parseInt((timer / 3600) % 24, 10)
            minutes = parseInt((timer / 60) % 60, 10)
            seconds = parseInt(timer % 60, 10);

            hours = hours < 10 ? "0" + hours : hours;
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.text(hours + ":" + minutes + ":" + seconds);

            --timer;
        }, 1000);
    }
    $(function ($) {
        var twelveHours = 12 * 60 * 60;
        var display = $('.order-form__timer');
        Timer(twelveHours, display);
    });
});

$(document).ready(function () {
    $(".single-comment__heart").each(function () {
        $(this).on("click", function () {
            $(this).toggleClass('liked');
        });
    });
});